export const MODAL_TYPES = {
  SHIPMENT_ADD_EDIT: 'SHIPMENT_ADD_EDIT',
  INVENTORY_ADD_EDIT: 'INVENTORY_ADD_EDIT',
  INSPECTIONPLAN_ADD_EDIT: 'INSPECTIONPLAN_ADD_EDIT',
  QUALITYAPPROVAL_ADD_EDIT: 'QUALITYAPPROVAL_ADD_EDIT',
  INSPECTIONRESULTS_ADD_EDIT: 'INSPECTIONRESULTS_ADD_EDIT',
  PRODUCTION_ADD_EDIT: 'PRODUCTION_ADD_EDIT',
  PARTS_ADD_EDIT: 'PARTS_ADD_EDIT',
  PARTS_PRINT: 'PARTS_PRINT',
  CUSTOMERS_ADD_EDIT: 'CUSTOMERS_ADD_EDIT',
  CARRIERS_ADD_EDIT: 'CARRIERS_ADD_EDIT',
  VENDOR_ADD_EDIT: 'VENDOR_ADD_EDIT',
  LOCATION_ADD_EDIT: 'LOCATION_ADD_EDIT',
  MACHINE_ADD_EDIT: 'MACHINE_ADD_EDIT',
  PROGRAM_ADD_EDIT: 'PROGRAM_ADD_EDIT',
  CONFIRM_MODAL: 'CONFIRM_MODAL',
  MOLDRECEIVING_ADD_EDIT: 'MOLDRECEIVING_ADD_EDIT',
  MOLDMAINTENANCE_ADD_EDIT: 'MOLDMAINTENANCE_ADD_EDIT',
  MOLDRELEASE_ADD_EDIT: 'MOLDRELEASE_ADD_EDIT',
  FUTUREACTIONS_ADD_EDIT: 'FUTUREACTIONS_ADD_EDIT',
  FUTUREACTIONS_DETAILS: 'FUTUREACTIONS_DETAILS',
  CELL_ADD_EDIT: 'CELL_ADD_EDIT',
  WORKTICKET_ADD_EDIT: 'WORKTICKET_ADD_EDIT',
  PO_ADD_EDIT: 'PO_ADD_EDIT',
  QUALITYALERT_ADD_EDIT: 'QUALITYALERT_ADD_EDIT',
  // Asset Management System modals
  AUXILIARY_EQUIPMENT_ADD_EDIT: 'AUXILIARY_EQUIPMENT_ADD_EDIT',
  FORKLIFT_ADD_EDIT: 'FORKLIFT_ADD_EDIT',
  WATER_TOWERS_ADD_EDIT: 'WATER_TOWERS_ADD_EDIT',
  AIR_COMPRESSORS_ADD_EDIT: 'AIR_COMPRESSORS_ADD_EDIT',
  PLANT_ADD_EDIT: 'PLANT_ADD_EDIT',
  ROBOTS_ADD_EDIT: 'ROBOTS_ADD_EDIT',
  OVERHEAD_CRANE_ADD_EDIT: 'OVERHEAD_CRANE_ADD_EDIT',
  LOCATION_PRINT_MODAL: 'LOCATION_PRINT_MODAL',
  CHANGEREQUEST_ADD_EDIT: 'CHANGEREQUEST_ADD_EDIT',
  CIPREGISTER_ADD_EDIT: 'CIPREGISTER_ADD_EDIT',
  // Add other modal types here
};
